const INVOICES_TO_SETTLE = 'invoicesToSettle';

export const saveInvoicesToSettle = (invoicesToSettle) => {
  localStorage.setItem(INVOICES_TO_SETTLE, JSON.stringify(invoicesToSettle));
};

export const getInvoicesToSettle = () => JSON.parse(localStorage.getItem(INVOICES_TO_SETTLE));

export const deleteInvoicesToSettle = () => {
  localStorage.removeItem(INVOICES_TO_SETTLE);
};

export default {
  saveInvoicesToSettle,
  getInvoicesToSettle,
  deleteInvoicesToSettle,
};
